import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import * as styles from './styles.css';
import { IconSuccess16, UIText2 } from '@cian/ui-kit';
import cn from 'classnames';
import { dropdownSeparator } from '../../../../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DropdownList(props) {
  var value = props.value,
      values = props.values,
      onValueChange = props.onValueChange;
  return /*#__PURE__*/_jsx("ul", {
    className: styles['list'],
    children: values.map(function (option, i) {
      var optionValue = option.value;
      var isActive = optionValue === value;

      if (optionValue === dropdownSeparator) {
        return /*#__PURE__*/_jsx("li", {
          className: styles['separator']
        }, i);
      }

      return /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs("button", {
          type: "button",
          className: cn(styles['button'], _defineProperty({}, styles['button__active'], isActive)),
          onClick: function onClick() {
            return onValueChange(optionValue);
          },
          children: [isActive && /*#__PURE__*/_jsx("span", {
            className: styles['button-active-icon'],
            children: /*#__PURE__*/_jsx(IconSuccess16, {
              color: "primary_100",
              display: "block"
            })
          }), /*#__PURE__*/_jsx(UIText2, {
            children: option.selectedLabel
          })]
        })
      }, "".concat(optionValue));
    })
  });
}